import appTranslationsHelper from "../../../languages/app-translations.helper";
import {
  DataLoadErrorType,
  DataLoadOfflineError,
  DataLoadAuthError,
  DataLoadUnexpectedError,
} from "./data-load-error";

const createUnexpectedError = (): DataLoadUnexpectedError => {
  const translations = appTranslationsHelper.getDataLoadErrorTranslations();

  return {
    type: DataLoadErrorType.UNEXPECTED,
    params: {},
    message: translations.unexpected,
  };
};

const createOfflineError = (): DataLoadOfflineError => {
  const translations = appTranslationsHelper.getDataLoadErrorTranslations();

  return {
    type: DataLoadErrorType.OFFLINE,
    params: {},
    message: translations.offline,
  };
};

const createAuthError = (): DataLoadAuthError => {
  const translations = appTranslationsHelper.getDataLoadErrorTranslations();

  return {
    type: DataLoadErrorType.UNAUTHORIZED,
    params: {},
    message: translations.unauthorized,
  };
};

const dataLoadErrorFactory = {
  createUnexpectedError,
  createOfflineError,
  createAuthError,
};

export default dataLoadErrorFactory;
